var Request = require('../helper/request');
var CompanyAssignment = require('./companyAssignment');
var User = require('./user');
var Category = require('./category');
var Logo = require('./logo');
var TagAssignment = require("./tagAssignment");

function Branch(app){
  var self = this;
  self.request = new Request(app);
  self.app = app;

  self.routes = {
    index: {
      url: '/branch',
      method: 'GET'
    },
    show: {
      url: '/branch/:id',
      method: 'GET'
    },
    create: {
      url: '/branch',
      method: 'POST'
    },
    update: {
      url: '/branch/:id',
      method: 'PUT'
    },
    delete: {
      url: '/branch/:id',
      method: 'DELETE'
    }
  };
}

Branch.prototype.index = function(){
  var self = this;
  return self.request.get(self.routes.index.url);
}

Branch.prototype.show = function(id){
  var self = this;
  var uri = self.routes.show.url.replace(':id', id);
  return self.request.get(uri);
}

Branch.prototype.create = function(){
  var self = this;
  return self.request.post(self.routes.create.url, {
    branch: data
  });
}

Branch.prototype.update = function(id, data){
  var self = this;
  var uri = self.routes.update.url.replace(':id', id);
  return self.request.put(uri, {
    branch: data
  });
}

Branch.prototype.delete = function(id){
  var self = this;
  var uri = self.routes.delete.url.replace(':id', id);
  return self.request.delete(uri);
}

Branch.prototype.companyAssignment = function(branchId){
  var self = this;
  return new CompanyAssignment(self.app, branchId);
}

Branch.prototype.user = function(branchId){
  var self = this;
  return new User(self.app, branchId);
}

Branch.prototype.category = function(branchId){
  var self = this;
  return new Category(self.app, branchId);
}

Branch.prototype.logo = function(branchId) {
  var self = this;
  return new Logo(self.app, branchId);
};

Branch.prototype.tagAssignment = function(branchId) {
  var self = this;
  return new TagAssignment(self.app, branchId)
}

module.exports = Branch;
